<template>
  <div id="section6" class="page-section6 section-observer" :class="{ 'is-visible': isVisible }">
    <img src="/img/ornamen_bunga.png" alt="Ornamen Kiri" loading="lazy" class="s6-ornamen">
    <img src="/img/ornamen_bunga.png" alt="Ornamen Kanan" loading="lazy" class="s6-ornamen-right">
    <img src="/img/Wayang-logo.png" alt="Wayang" loading="lazy" class="s6-wayang fade-on-scroll">

    <h2 class="s6-title fade-on-scroll">Our Story</h2>
    <img :src="couplePhotoUrl" alt="Our Story" loading="lazy" class="s6-photo fade-on-scroll">

    <div class="s6-timeline">
      <div v-for="(item, i) in story" :key="i" class="timeline-item fade-on-scroll">
        <h3 class="timeline-title">{{ item.title }} <span class="line"></span></h3>
        <p>{{ item.description }}</p>
      </div>
      <!-- Fallback saat story kosong -->
      <div v-if="!story.length" class="timeline-item fade-on-scroll">
        <h3 class="timeline-title">Our Story <span class="line"></span></h3>
        <p>Kisah cinta kami dimulai dengan pertemuan sederhana yang penuh makna...</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useInvitationStore } from '@/store';

export default {
  name: 'OurStorySection',
  data() {
    return { isVisible: false };
  },
  computed: {
    ...mapState(useInvitationStore, ['client', 'story', 'randomGalleryPicks']),
    couplePhotoUrl() {
      const pick = this.randomGalleryPicks?.[2];
      if (pick) return `https://admin.itsyourdayofficial.com/gallery/${encodeURIComponent(pick)}`;
      const foto = this.client.foto_couple || this.client.foto_cover;
      return foto
        ? `https://admin.itsyourdayofficial.com/foto_cover/${foto}`
        : 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=600&q=80';
    },
  },
  mounted() {
    this.setupSectionObserver();
    this.setupFadeObserver();
  },
  beforeUnmount() {
    if (this._sectionObserver) this._sectionObserver.disconnect();
    if (this._fadeObserver) this._fadeObserver.disconnect();
  },
  methods: {
    setupSectionObserver() {
      if (typeof IntersectionObserver === 'undefined') return;
      this._sectionObserver = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) this.isVisible = true; },
        { threshold: 0.15 }
      );
      this._sectionObserver.observe(this.$el);
    },
    setupFadeObserver() {
      if (typeof IntersectionObserver === 'undefined') return;
      const observer = new IntersectionObserver(
        (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('is-visible'); }),
        { threshold: 0.15 }
      );
      this.$el.querySelectorAll('.fade-on-scroll').forEach(el => observer.observe(el));
      this._fadeObserver = observer;
    },
  },
};
</script>

<style scoped>
.fade-on-scroll { opacity: 0; transform: translateY(40px); transition: opacity 1s ease-out, transform 1s ease-out; }
.fade-on-scroll.is-visible { opacity: 1; transform: translateY(0); }

.page-section6 {
  background-color: #4A5C74; color: #ffffff; padding: 6rem 2rem;
  display: flex; flex-direction: column; align-items: center; position: relative; overflow: hidden;
}
.s6-ornamen {
  position: absolute; top: -30px; left: -50px; width: 200px;
  transform: rotate(-15deg); transform-origin: center center; opacity: 0; pointer-events: none;
}
.s6-ornamen-right {
  position: absolute; top: 35%; right: -80px; width: 220px;
  transform: scaleX(-1) rotate(-15deg); transform-origin: center center; opacity: 0; pointer-events: none; z-index: 10;
}
.page-section6.is-visible .s6-ornamen {
  animation: slideDown-orn 1.5s cubic-bezier(0.2,0.8,0.2,1) forwards, float-orn 6s ease-in-out infinite 1.5s;
}
.page-section6.is-visible .s6-ornamen-right {
  animation: slideLeft-orn 1.5s cubic-bezier(0.2,0.8,0.2,1) forwards, float-orn-right 6s ease-in-out infinite 1.5s;
}
@keyframes slideDown-orn {
  0%   { opacity: 0; transform: rotate(-15deg) translateY(-100px); }
  100% { opacity: 0.95; transform: rotate(-15deg) translateY(0px); }
}
@keyframes slideLeft-orn {
  0%   { opacity: 0; transform: scaleX(-1) rotate(-15deg) translateX(-100px); }
  100% { opacity: 0.95; transform: scaleX(-1) rotate(-15deg) translateX(0px); }
}
@keyframes float-orn {
  0%, 100% { transform: rotate(-15deg) translateY(0px); }
  50%       { transform: rotate(-15deg) translateY(-14px); }
}
@keyframes float-orn-right {
  0%, 100% { transform: scaleX(-1) rotate(-15deg) translateY(0px); }
  50%       { transform: scaleX(-1) rotate(-15deg) translateY(-14px); }
}
.s6-wayang { width: 90px; margin-bottom: 1.5rem; filter: brightness(0) invert(1); opacity: 0.9; z-index: 2; }
.s6-title { font-family: 'Great Vibes', cursive; font-size: 3.5rem; font-weight: normal; margin-bottom: 2rem; z-index: 2; }
.s6-photo { width: 95%; max-width: 500px; border-radius: 20px; box-shadow: 0 10px 25px rgba(0,0,0,0.15); border: 3px solid rgba(255,255,255,0.9); margin-bottom: 3.5rem; z-index: 2; }
.s6-timeline { display: flex; flex-direction: column; gap: 2.5rem; width: 100%; max-width: 500px; text-align: left; z-index: 2; }
.timeline-item { display: flex; flex-direction: column; gap: 0.8rem; }
.timeline-title { display: flex; align-items: center; gap: 15px; font-family: 'Great Vibes', cursive; font-size: 2.5rem; font-weight: normal; }
.timeline-title .line { flex: 1; height: 1px; background-color: #ffffff; }
.timeline-item p { font-size: 1.05rem; line-height: 1.6; opacity: 0.95; font-family: 'Cormorant Garamond', serif; padding-right: 10px; }

@media (max-width: 767px) {
  .s6-title { font-size: 3rem; }
  .timeline-title { font-size: 2rem; }
  .timeline-item p { font-size: 0.95rem; }
}
</style>
